import { createSlice } from "@reduxjs/toolkit";
import { updateTrainingViewCount, updateTrainingWatchedSecs } from "../data/dataSlice";

const initialState = {
  toggle: true,
  data: {}, // Selected training details
  tasksData: {}, // Selected task details
  trainingData: [], // Cached training data
  lastFetched: 0, // Timestamp of the last fetch
  activeTaskId: null, // Add this new state
  currentVisitCount: null,
};

const contentTrainingSlice = createSlice({
  name: "contentTraining",
  initialState,
  reducers: {
    selectTraining: (state, { payload }) => {
      state.data = payload; // Update selected training details
    },
    toggleHandler: (state) => {
      state.toggle = !state.toggle;
    },
    setCurrentVistCount: (state, { payload }) => {
      state.currentVisitCount = payload; // Update selected training details
    },
    setToggleTrueHandler: (state) => {
      state.toggle = true;
    },
    setToggleFalseHandler: (state) => {
      state.toggle = false;
    },
    selectedTask: (state, { payload }) => {
      state.tasksData = payload;
    },

    setTrainingData: (state, { payload }) => {
      state.trainingData = payload.data || [];
      state.lastFetched = payload.lastFetched || Date.now();
    },
    logoutTraining: () => initialState,
    setActiveTaskId: (state, { payload }) => {
      state.activeTaskId = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTrainingViewCount.fulfilled, (state, { payload }) => {
        const secs = payload?.data?.[0]?.[0]?.fields?.watched_training_task_secs;
        if (secs !== undefined && state.data) {
          state.data.watched_training_task_secs = secs;
        }
      })
      .addCase(updateTrainingWatchedSecs.fulfilled, (state, { payload }) => {
        const secs = payload?.data?.[0]?.[0]?.fields?.watched_training_task_secs;
        if (secs !== undefined && state.data) {
          state.data.watched_training_task_secs = secs;
        }
      });
  },
});

export const {
  selectTraining,
  setCurrentVistCount,
  toggleHandler,
  selectedTask,
  setTrainingData,
  logoutTraining,
  setToggleTrueHandler,
  setToggleFalseHandler,
  setActiveTaskId, // Export the new action
} = contentTrainingSlice.actions;
export default contentTrainingSlice.reducer;
